import {ConfigObjectType} from '@wallaby-ui/core';
import {useMedications, useNavigationContext, useValuesToCopy} from '@wallaby-ui/document';
import {AppLayout} from '@wallaby-ui/layout';
import * as React from 'react';

import {AppLayoutContent} from './AppLayoutContent';
import navigationConfig from '../../../config/common/navigation_config';

interface OwnProps {
  config: ConfigObjectType;
}
type Props = OwnProps;

export const AppLayoutContainer: React.FC<Props> = (props) => {
  const {config} = props;
  useMedications(config, 'MEDICINAL_PRODUCT'); // NOTE: PDM-1457 preload medications
  const navigationContext = useNavigationContext(config, navigationConfig as any);
  const {valuesToCopy, setValuesToCopy} = useValuesToCopy();
  const isLoading = false;
  return isLoading ? null : (
    <AppLayout
      config={config}
      logoName={'merieLogo.svg'}
      logoSignName={'arrowLogoSign_white.svg'}
      navigationContext={navigationContext}
      valuesToCopy={valuesToCopy}
    >
      <AppLayoutContent
        config={config}
        navigationContext={navigationContext}
        valuesToCopy={valuesToCopy}
        setValuesToCopy={setValuesToCopy}
      />
    </AppLayout>
  );
};
